import type { FaireProductEntity } from "../../entity_types/product";

export const p_ehjj32n4ke: FaireProductEntity = {
  token: "p_ehjj32n4ke",
  type: "product",
  name: "Petite Rituals",
  brandToken: "b_6bmpg4myaw",
  brandName: "Ollie Blossom",
  imageUrl:
    "https://cdn.faire.com/fastly/27591e37ca5d1956a4a637989059749e8e395f6409b57bd4f9a72ae6f4075713.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f8564c75ac1d88fc96495b9f2a9b50b1ee867a64a5f14ab097faf9a7acaddc3f.jpeg",
    "https://cdn.faire.com/fastly/b0cf1c72a3fcf3cb373e97cc84553874c987236ef08468213d3fb3060d74b2c7.jpeg",
    "https://cdn.faire.com/fastly/4e468129da1f49fb4546dc669e6e840cc6dc71c7fd96353cd8e7b87fc63c3877.jpeg",
    "https://cdn.faire.com/fastly/c4e25564b0235acc30949edb231168772ef6bfe1b9c920f91cd5c61f6fef6b22.png",
  ],
  priceDollars: 18,
  description:
    "A perfect gift set for Mother's Day! Let her unwind with a soak, face mask, and steam.\n\nContains: \n\n1  Bath Soak in Compostable* bag with Himalayan Pink Salt, Epsom Salt & Lavender       Essential Oil\n\n1  Face Mask packaged in Compostable* bag with Rose (Kaolin) Clay, Colloidal       Oatmeal, Lavender Flower, Rose Hips\n\n1  Natural Birchwood Mask Applicator\n\n1  Moisturizing Facial Steam packaged in a Compostable* bag with Rose Petals, Eucalyptus, c/s Comfrey leaf, c/s Marshmallow leaf, c/s Chamomile, Marigold (Calendula Officinalis)\n\nHow to Enjoy: \n\nBath: Reflect & bring awareness to your surroundings. In a bath, dissolve in warm water. \n\nMask: Mix mask with 1/2 tsp at a tome of carrier (water/oil) until you reach desired consistency.",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:16.131Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
